import { Outlet } from "react-router-dom";

export function Order() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
